import React, { useState,useContext } from "react";
import "./Swap.css";
import ecricon from  '../icons/ecr.png';
import ethericon from '../icons/ether.png';
import swapicon from '../icons/swap.png';

import Button from "@material-ui/core/Button";
import UserContext from "../Contexts/UserContext";
import Web3 from "web3";
 
export default function SwapEcrToEth({setswapchild}) {
    window.document.title = "Swap";
    const context = useContext(UserContext);
  
    let [fromAmt, setfromAmt] = useState(0);
    let [toAmt, settoAmt] = useState(0);
    
    const EcrToEth = (value) => {
      context.sellTokens(Web3.utils.toWei(Web3.utils.toBN(value), "ether"));
    }
  
  
    return (
      <section className="root">
        <div id="swapcontainer">
          <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
            <h1 id="heading">Swap</h1>
            <button 
              id='swap_from_to_btn' 
              onClick={()=>{
                setswapchild(prev=>{
                  return !prev
                })
              }}
            >
              <img src={swapicon} style={{display:'block',margin:'auto',width:'100%',transform:'scale(1.2)'}}/>
            </button>
          </div>
          <div className="childcontainer">
          <div style={{display:'flex',flexDirection:'column',padding:'5px',color:'white'}}>
              FROM
              <Button
                  className="modalbtn"
                  variant="outlined"
                  color="primary"
                >
                <img src={ecricon} width='24px' style={{marginRight:'4px'}}/>
                  ECR
              </Button>
            </div>
          <div className='from'>
              Balance: {Web3.utils.fromWei(Web3.utils.toBN(context?.tokenBalance), "ether")}
              <input
                id="enterfromamount"
                onChange={(e) => {
                  setfromAmt(e.target.value);
                  settoAmt(e.target.value/100);
                }}
                value={fromAmt}
                type="text"
              />
            </div>
        </div>
          <div className="childcontainer" >
            <div style={{display:'flex',flexDirection:'column',padding:'5px',color:'white'}}>
              TO
              <Button
                  className="modalbtn"
                  variant="outlined"
                  color="primary"
                >
                <img src={ethericon} width='24px' style={{marginRight:'4px'}}/>
                  ETH
              </Button>
            </div>
            <div className='to'>
              Balance: {Web3.utils.fromWei(Web3.utils.toBN(context?.ethBalance), "ether")}
              <input
                id="entertoamount"
                onChange={(e) => {
                  setfromAmt(e.target.value);
                }}
                value={toAmt}
                disabled={true}
                type="text"
              />
          </div>
        </div>
          
          <Button
            style={{ marginTop: "10px", width: "100%", fontSize: "1.4rem" }}
            variant="contained"
            color="primary"
            onClick={()=>{
              if(fromAmt==='' || fromAmt===undefined || fromAmt<=0){
                alert('Enter amount')
              }
              else{EcrToEth(fromAmt)}
            }}
          >
          
            SWAP
          </Button>
        </div>
      </section>
    );
  }
  